export const GET_CAR_BRANDS_REQUEST = "GET_CAR_BRANDS_REQUEST";
export const GET_CAR_BRANDS_SUCCESS = "GET_CAR_BRANDS_SUCCESS";

export const SHOW_CAR_BRAND_REQUEST = "SHOW_CAR_BRAND_REQUEST";
export const SHOW_CAR_BRAND_SUCCESS = "SHOW_CAR_BRAND_SUCCESS";

export const SHOW_CAR_BRANDS_REQUEST = "SHOW_CAR_BRANDS_REQUEST";
export const SHOW_CAR_BRANDS_SUCCESS = "SHOW_CAR_BRANDS_SUCCESS";

export const POST_CAR_BRAND_REQUEST = "POST_CAR_BRAND_REQUEST";
export const POST_CAR_BRAND_SUCCESS = "POST_CAR_BRAND_SUCCESS";

export const PUT_CAR_BRAND_REQUEST = "PUT_CAR_BRAND_REQUEST";
export const PUT_CAR_BRAND_SUCCESS = "PUT_CAR_BRAND_SUCCESS";

export const DELETE_CAR_BRAND_REQUEST = "DELETE_CAR_BRAND_REQUEST";
export const DELETE_CAR_BRAND_SUCCESS = "DELETE_CAR_BRAND_SUCCESS";
